export const getDataForPage = (page: number, pageSize: number, data: any[]) => {
    if (data) {
        const startIndex = (page - 1) * pageSize
        const endIndex = page * pageSize
        return data.slice(startIndex, endIndex)
    }
    return []
}
